import React from "react";

import { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";

import Table from "../../../../Components/UiComponents/Table/Table";
import { getMealsDetailsURL } from "../../../../Services/EndPoints";
import { postDataWithBody } from "../../../../Services/Services";

// Row order for the meal breakdown table: adult Males, then adult Females,
// then adult Transgender, then every "Children ..." row regardless of
// gender (so children don't get split up and interleaved into the middle
// of the Male block), with "Total" always last. Within each adult group,
// the plain label (e.g. "Transgender") comes before its variants (e.g.
// "Transgender Disabled").
function getAttributeSortRank(attribute) {
  if (attribute === "Total") return [2, 0, 0];
  const isChildren = attribute.includes("Children");
  let gender = 3;
  if (attribute.includes("Male") && !attribute.includes("Female")) gender = 0;
  else if (attribute.includes("Female")) gender = 1;
  else if (attribute.includes("Transgender")) gender = 2;
  const isBaseLabel = attribute === "Males" || attribute === "Females" || attribute === "Transgender";
  return [isChildren ? 1 : 0, gender, isBaseLabel ? 0 : 1];
}

const CommunityKitchenBreakFastDetails = (props) => {
  const { t } = useTranslation();
  const [breakfastData, setBreakFastData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  useEffect(() => {
    getMealsDetailsData(props.mealTypeCd, props.facilityreportId);
  }, []);

  const getMealsDetailsData = async (mealTypeCd, facilityreportId) => {
    let inputobj = {
      facilityReportIds: [parseInt(facilityreportId)],
      facilityOfferingTypeCd: mealTypeCd,
    };
    var mealdataarr = await postDataWithBody(getMealsDetailsURL, inputobj, {});

    let totalAmount = 0;
    mealdataarr.forEach(function (data, node) {
      if (
        data.facility_report_attribute_value &&
        !isNaN(data.facility_report_attribute_value)
      ) {
        totalAmount += parseInt(data.facility_report_attribute_value);
      }
    });
    mealdataarr.push({
      attribute: "Total",
      facility_report_attribute_value: totalAmount,
    });

    mealdataarr.sort((a, b) => {
      const [groupA, genderA, baseA] = getAttributeSortRank(a.attribute);
      const [groupB, genderB, baseB] = getAttributeSortRank(b.attribute);
      if (groupA !== groupB) return groupA - groupB;
      if (genderA !== genderB) return genderA - genderB;
      if (baseA !== baseB) return baseA - baseB;
      return 0; // preserve the API's original order within the same bucket
    });
    
    setRowCount(mealdataarr.length);
    setBreakFastData(mealdataarr);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: t("communitykitchenpopuptable.name"),
        accessor: "attribute",
        disableSortBy: true,
      },
      {
        Header: t("communitykitchenpopuptable.value"),
        accessor: "facility_report_attribute_value",
        disableSortBy: true,
      },
    ],
    []
  );
  return (
    <div>
      <div className="container  create-user">
        <div className="datatable__container">
          {breakfastData && (
            <Table
              data={breakfastData}
              addButtonLabel="Create UserTask"
              columns={columns}
              numberOfRows={7}
              showExport={false}
              showFilter={false}
              showReset={false}
              onExpand={false}
              rowCount={rowCount} // Pass rowCount to the Table component
              headerTableHeadStyle={{ background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)", color: "#FFFFFF" }}
              tableStyle={{
                border: "1px solid  #f0f0f0",
                padding: "2px",
                borderRadius: "12px",
              }}
              applyTableHeaderCustomClass={true}
              disbalePaginationFilter={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CommunityKitchenBreakFastDetails;
